export const globalEnvMap = {
    PUBLIC_AUTH_API_URL: window.appConfig?.PUBLIC_AUTH_API_URL,
    PUBLIC_BANKS_API_URL: window.appConfig?.PUBLIC_BANKS_API_URL,
    PUBLIC_PAYOUT_API_URL: window.appConfig?.PUBLIC_PAYOUT_API_URL,
    PUBLIC_PAYIN_API_URL: window.appConfig?.PUBLIC_PAYIN_API_URL,
} as const satisfies AppConfig;

export const devEnvMap = {
    PUBLIC_AUTH_API_URL: import.meta.env.PUBLIC_AUTH_API_URL,
    PUBLIC_BANKS_API_URL: import.meta.env.PUBLIC_BANKS_API_URL,
    PUBLIC_PAYOUT_API_URL: import.meta.env.PUBLIC_PAYOUT_API_URL,
    PUBLIC_PAYIN_API_URL: import.meta.env.PUBLIC_PAYIN_API_URL,
} as const satisfies AppConfig;
